var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    fill: "none",
    viewBox: "0 0 9 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#161C27",
    d: "M8.704 10.332c0 .533-.133 1.035-.4 1.504-.256.47-.64.864-1.152 1.184-.501.32-1.099.512-1.792.576v1.296H4.32v-1.296c-1.003-.096-1.813-.41-2.432-.944-.619-.533-.928-1.237-.928-2.112h1.952c.032.416.165.763.4 1.04.235.267.57.437 1.008.512v-3.52a13.872 13.872 0 01-1.744-.544 2.92 2.92 0 01-1.152-.896c-.31-.405-.464-.96-.464-1.664 0-.885.31-1.616.928-2.192.619-.587 1.43-.928 2.432-1.024V.956h1.04v1.296c.939.085 1.69.384 2.256.896.576.501.901 1.195.976 2.08H6.64a1.531 1.531 0 00-.384-.88 1.68 1.68 0 00-.896-.544V7.26c.715.17 1.296.352 1.744.544.448.181.827.475 1.136.88.31.395.464.944.464 1.648zm-5.888-4.96c0 .437.128.779.384 1.024.267.245.64.443 1.12.592V3.756c-.459.053-.827.219-1.104.496-.267.277-.4.65-.4 1.12zm2.544 6.72c.47-.075.837-.261 1.104-.56.267-.31.4-.677.4-1.104 0-.427-.133-.757-.4-.992-.256-.245-.624-.443-1.104-.592v3.248z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/Currency.aa80ab9f022fd0c108a598a5c8b6af6e.svg";
export { ForwardRef as ReactComponent };